var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPre(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    transform: "matrix(-1 0 0 1 18 0)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 0C13.9666 0 18 4.03338 18 9C18 13.9666 13.9666 18 9 18C4.03338 18 0 13.9666 0 9C0 4.03338 4.03338 0 9 0ZM9 0.692308C4.40792 0.692308 0.692307 4.40792 0.692307 9C0.692307 13.5921 4.40792 17.3077 9 17.3077C13.5921 17.3077 17.3077 13.5921 17.3077 9C17.3077 4.40792 13.5921 0.692308 9 0.692308ZM10.5923 5.53846L11.0769 5.99538L7.89231 9L11.0769 12.0046L10.5923 12.4615L6.92308 9L10.5923 5.53846Z",
    fill: "#929292"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPre);
export default __webpack_public_path__ + "static/media/pre.e3286c5f12c9b63c185cda2644ea371d.svg";
export { ForwardRef as ReactComponent };